import { render, staticRenderFns } from "./channel_banner.vue?vue&type=template&id=08d9d8e9&scoped=true"
import script from "./channel_banner.vue?vue&type=script&lang=js"
export * from "./channel_banner.vue?vue&type=script&lang=js"
import style0 from "./channel_banner.vue?vue&type=style&index=0&id=08d9d8e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9d8e9",
  null
  
)

export default component.exports